// Module
var code = "<div class=\"menu-item{{class}}\" id=\"{{id}}\" {{country}} {{locale}}> <a ref=\"{{follow}}\" href=\"{{url}}\"> <div class=\"icon\"><img alt=\"{{id}}\" src=\"{{icon}}\"/></div> <div class=\"icon hover\"><img alt=\"{{id}}\" src=\"{{iconHover}}\"/> </div> <div data-i18n=\"{{label}}\" class=\"text\"></div> </a> </div>";
// Exports
module.exports = code;